export class Property {
  constructor(id, value) {
    this.id = id;
    this.value = value;
  }
}

export default class RelatedModel {
  constructor(data) {
    this.id = data.id;
    this.code = data.code;
    this.image = data.image || data.cover || data.coverImage;
    this.name = (data.getTranslatedName && data.getTranslatedName()) || data.name;
    this.category = data.categoryId ? new Property(data.categoryId, data.category) : data.category;
    this.collection = data.collection;
    this.gender = data.genderId ? new Property(data.genderId, data.gender) : data.gender;
    this.isProduct = !!data.getTranslatedName;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/related/related.model.js